module.exports = __webpack_public_path__ + "assets/media/moreMenu-vk.d46076da.svg";